import { useRef as n, useCallback as u } from "react";
const o = (r) => {
  const e = n(r);
  return e.current = r, u((...t) => e.current(...t), []);
};
export {
  o as useFunction
};
//# sourceMappingURL=index2.js.map
